export const allAreaExpertise = [
	"management",
	"computer_science",
	"marketing ",
	"accounting ",
	"economy",
	"communication",
	"finance",
	"project_management",
	"graphic_design",
	"UX_UI_design",
	"human_and_social_sciences",
	"mathematics",
	"physic_chemistry",
	"english",
	"french",
	"philosophy",
	"gastronomy",
	"hospitality ",
	"media",
	"real_estate",
	"copywriter ",
	"literature",
	"data_science",
	"entrepreneurship",
	"justice_law",
] as const;

export type AreaExpertise = (typeof allAreaExpertise)[number];
